import useDeleteApi from './useDeleteApi';
import { url } from '../../utils/confserveur';
export const useDeleteEval = () => {
  const { deleteData, isLoading, error } = useDeleteApi();

  const deleteEvaluation = async (evalId) => {
    const urldelete = `${url}evaluations/${evalId}/`;
    await deleteData(urldelete);
  };

  return { deleteEvaluation, isLoading, error };
};